import React, { useEffect, useRef, useState } from 'react';
import './AdminStream.scss'
import video from '../../../assets/event_placeholder.png'
import play from '../../../assets/player_overlay.png' 
import firebase from '../../../utils/firebase'
import { Slider, withStyles, Tooltip } from '@material-ui/core';
import screenfull from 'screenfull';
import { useDispatch, useSelector } from 'react-redux';
import { setLoadFailed, setLoadSuccess } from '../../../redux/actions/s2txtActions';
import ReactPlayer from 'react-player'

const VolumeSlider = withStyles({
    root: {
      color: 'rgb(230, 230, 230)',
      height: 0,
      padding: 0,
      paddingTop: 2,
      margin: '0.1rem 0 0 0',
     
      width: 100,
     
     
    },
    thumb: {
      height: 10,
      width: 10,
      backgroundColor: 'rgb(230, 230, 230)',
      border: '1px solid rgb(230, 230, 230)',
      marginTop: -4,
      marginLeft: -0,
      '&:focus, &:hover, &$active': {
        boxShadow: 'inherit',
      },
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 4px)',
    },
    track: {
      height: 3,
      borderRadius: 4,
    },
    rail: {

      height: 3,
      borderRadius: 4,
      backgroundColor: '#525252',
      opacity: 1
    },
  })(Slider);


function ValueLabelComponent(props) {
    const { children, open, value } = props;
  
    return (
      <Tooltip open={open} enterTouchDelay={0} placement="top" title={value}>
        {children}
      </Tooltip>
    );
  }

  const PrettoSlider = withStyles({
    root: {
      color: '#da3849',
      height: 0,
      padding: 0,
      paddingTop: 3,
      position: 'absolute',
      top: -6,
      width: '98.8%'
     
    },
    thumb: {
      height: 10,
      width: 10,
      backgroundColor: '#da3849',
      border: '2px solid currentColor',
      marginTop: -4,
      marginLeft: -0,
      '&:focus, &:hover, &$active': {
        boxShadow: 'inherit',
      },
    },
    active: {},
    valueLabel: {
      left: 'calc(-50% + 4px)',
    },
    track: {
      height: 3,
      borderRadius: 4,
    },
    rail: {

      height: 3,
      borderRadius: 4,
      backgroundColor: '#909090',
      opacity: 1
    },
  })(Slider);

  const getDate = () => {
    const months = {
    0: 'Jan',
    1: 'Feb',
    2: 'Mar',
    3: 'Apr',
    4: 'May',
    5: 'Jun',
    6: 'Jul',
    7: 'Aug',
    8: 'Sept',
    9: 'Oct',
    10: 'Nov',
    11: 'Dec'
    }
    let date = ('00' + new Date(Date.now()).getDate()).slice(-2)
    let month = months[new Date(Date.now()).getMonth()]
    
  
    return [date, month]
  }


const AdminStream = () => {

    const loadingStatus = useSelector(state => state.loadingStatus)
    const { status } = loadingStatus
    const dispatch = useDispatch()

    const [error, setError] = useState(!status);
    const [languagesData, setLanguagesData] = useState([]);
    const [eventsData, setEventsData] = useState([]);
    const [eventTitle, setEventTitle] = useState('');
    const [eventStatus, setEventStatus] = useState('');
    const [eventDate, setEventDate] = useState('');
    const [eventTime, setEventTime] = useState('');
    const [eventDescription, setEventDescription] = useState('');
    const [eventImage, setEventImage] = useState('');
    const [playState, setPlayState] = useState('play');
    const [day, setDay] = useState('');
    const [month, setMonth] = useState('')
    const [language, setLanguage] = useState('English')
    const [loadVideo, setLoadVideo] = useState(false);
    const [playing, setPlaying] = useState(false)
    const [mute, setMute] = useState(false);
    const [volume, setVolume] = useState(0.5);
    const [duration, setDuration] = useState(1);
    const [videoLength, setVideoLength] = useState('00:00');
    const [currentTime, setCurrentTime] = useState('00:00');
    const [seekTime, setSeekTime] = useState('');
    const [videoSrc, setVideoSrc] = useState('');
    const [gg, setgg] = useState('');
    const [pbr, setPbr] = useState(1);
    const [progress, setProgress] = useState({
        played: 0,
        playedSeconds: 0,
        seeking: false
    });

    const {played, playedSeconds, seeking} = progress
    const playerRef = useRef(null)
    const playerContainerRef = useRef(null)
    const controlRef = useRef(null)

    useEffect(() => {
        let ff = getDate()
        setDay(ff[0])
        setMonth(ff[1])
    }, [])

    
    useEffect(() => {
        const langRef = firebase.database().ref('Languages')

        langRef.on('value', (el) => {
            let eData = []
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }
            
            setLanguagesData(eData)
           
        })
    }, [])

    useEffect(() => {
        languagesData.forEach(el => {
            if(el.language === 'English') {
                setVideoSrc(el.streamUrl)
            }
        })
    }, [languagesData])


    useEffect(() => {
        const eventRef = firebase.database().ref('Events')

        eventRef.on('value', (el) => {
            let eData = []
            console.log('here')
            for (let id in el.val()) {
                eData.push({id, ...el.val()[id]})
            }

            if (eData.length !== eventsData.length) {
                setEventsData(eData)
            } else {
                for (let i = 0; eData.length < i; i++) {
                
                    if (eData[i] !== eventsData[i]) {
                        
                    };
                }
            }

            

            
        })

        const check = eventsData.some(el => {
            return el.eventStatus === 'Live'
        })

        if(check) {
            eventsData.forEach(el => {
                if (el.eventStatus === 'Live') {
                    setEventTitle(el.eventName)
                    setEventDate(el.eventDate)
                    setEventTime(el.eventTime)
                    setEventStatus(el.eventStatus)
                    setEventDescription(el.description)
                    setEventImage(el.eventImageUrl)
                    return
                }
            })
        }
        if (!check) {
            eventsData.forEach(el => {
                if (el.eventStatus === 'Default') {
                    setEventTitle(el.eventName)
                    setEventDate(el.eventDate)
                    setEventTime(el.eventTime)
                    setEventStatus(el.eventStatus)
                    setEventDescription(el.description)
                    setEventImage(el.eventImageUrl)
                    
                    return
                }
            })  
                
            }
    }, [eventsData])


    

    const timeFormat = (s) => {   
    let hrs = Math.floor(s / 3600);
    let mins = Math.floor((s % 3600) / 60);
    let secs = Math.floor(s % 60);
    let ret = "";

    if (hrs > 0) {
        ret += "" + hrs + ":" + (mins < 10 ? "0" : "");
    }

    ret += "" + mins + ":" + (secs < 10 ? "0" : "");
    ret += "" + secs;
    return ret;
    }

    useEffect(() => {
        setVideoLength(timeFormat(duration))
    }, [duration])

    const handlePlay = () => {
        setPlaying(true)
        setPlayState('play')
    }

    const handlePause = () => {
        setPlaying(false)
        setPlayState('pause')
    }

    const handleVideoStart = () => {
        setPlaying(true)
        setLoadVideo(true)
    }

    const handleChange = (e, newValue) => {
        setVolume(newValue)
    }

    const handleMute = () => {
        setMute(!mute)
    }

    const toggleFullScreen = () => {
        screenfull.toggle(playerContainerRef.current)
    }

    const handleProgress = (changeState) => {
        setError(false)
        setCurrentTime(timeFormat(playedSeconds))
        if(!seeking) {
            setProgress({...changeState})
            setSeekTime(timeFormat(playedSeconds))
        }
        setgg((playedSeconds/duration) * 100)

    }

    const handleDuration = (changeState) => {
        
        setDuration(parseInt(changeState))
        
        
    }

    const onSeek = (e, newValue) => {
        setProgress({
            ...progress,
            played: parseFloat(newValue / 100)
        })
        setSeekTime(timeFormat(played * duration))
    }


    const onSeekMouseDown = (e, newValue) => {
        setProgress({
            ...progress,
            seeking: true,
            played: parseFloat(newValue / 100)
        })
    }

    const onSeekMouseUp = (e, newValue) => {
        setProgress({
            ...progress,
            seeking: false
        })
        playerRef.current.seekTo(newValue / 100)
    }

    const handleError = () => {
        dispatch(setLoadFailed())
    }

    const handleReady = () => {
        dispatch(setLoadSuccess())
    }

    const handleMouseOver = () => {
        if (document.querySelector('.video-controls')) {
            document.querySelector('.video-controls').classList.remove('hide')
        }
 
    }

    const handleMouseLeave = () => {
        if (document.querySelector('.video-controls')) {
            document.querySelector('.video-controls').classList.add('hide')
        }
    }
    
    

    return (
        <div className="admin-stream">
            <div className="admin-lang">
                <p>Language:</p>
                <p>{language}</p>
            </div>

            <div className="stream">
                <div className="top">
                    <div className="t-left">
                        <p>{day}</p>
                        <p>{month}</p>
                    </div>

                    <div className='t-right'>
                        <i>Now showing</i>
                        <h2>{eventTitle}</h2>
                    </div>
                </div>

                <div className="middle" onMouseOver={handleMouseOver} onMouseLeave={handleMouseLeave}>
                    {!loadVideo?
                        <div ref={playerContainerRef} className="video ">
                            <img src={eventImage} alt="cover" />
                            <img src={play} alt="play button" onClick={handleVideoStart}/>
                        </div>
                    : !error?
                    <div ref={playerContainerRef} className="video " >
                    
                        <ReactPlayer
                        ref={playerRef}
                        className='react-player '
                        width='100%'
                        height='100%'
                        url={videoSrc}
                        muted={mute}
                        playing={playing}
                        volume={volume}
                        playbackRate={pbr}
                        onProgress={handleProgress}
                        onDuration={handleDuration}
                        onPlay={handlePlay}
                        onPause={handlePause} 
                        onError={handleError} 
                        onReady={handleReady}
                        
                        />

                        <div className="video-controls">
                            <PrettoSlider 
                            min={0}
                            max={100}
                            defaultValue={0}
                            value={played *100}
                            onChange={onSeek}
                            onMouseDown={onSeekMouseDown}
                            onChangeCommitted={onSeekMouseUp}
                            ValueLabelComponent={(props) => (
                            <ValueLabelComponent {...props} value={seekTime}/>)}
                            />

                            <div className="controls">
                                <div className="left">
                                    {playState === 'play'? <i class="fas fa-pause" onClick={handlePause}></i> : <i class="fas fa-play" onClick={handlePlay}></i>}
                                    
                                    
                                 
                                    {mute ? <i class="fas fa-volume-mute volume" onClick={handleMute}></i> : volume <= '0.5'? <i class="fas fa-volume-down volume"  onClick={handleMute}></i> : <i class="fas fa-volume-up volume" onClick={handleMute}></i>}
                                    
                                    <VolumeSlider                                
                                    value={volume} onChange={handleChange} 
                                    aria-labelledby="continuous-slider" 
                                    step={0.015}  
                                    min={0}
                                    max={1}
                                    disabled={mute}/>
                                </div>

                                <div className="right">
                                    <div className="duration">
                                        {currentTime} / {videoLength}
                                    </div>
                                 
                                    <div className="rectangle" onClick={toggleFullScreen}></div>
                                </div>
                            </div>    
                        </div>
                    </div>
                    : <div className="error-container">
                        
                        <p>Your Either Having Network Issues Or The Stream You Selected Isn't Live Yet</p>
                    </div>
                    }    
                </div>

                <div className='bottom'>
                    <p>
                        {eventDescription}
                    </p>
                </div>
            </div>

            <div className="stream-detail">
                <div className="detail">
                    <h3>Event</h3>
                    <p>{eventTitle}</p>
                    <div className="line"></div>
                </div>

                <div className="detail">
                    <div className="contain">
                        <div className="left">
                            <h3>Date:</h3>
                            <p>{eventDate}</p>
                        </div>

                        <div className="right">
                            <h3>Time</h3>
                            <p>{eventTime}</p>
                        </div>
                    </div>
                    
                    <div className="line"></div>
                </div>

                <div className="stream-status">
                    <h3>Live:</h3>
                    {eventStatus === 'Live'?  <p>Live</p>:  <p className='default'>No Event Is Live</p>}
                   
                </div>
            </div>
        </div>
    )
}

export default AdminStream